import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { ListItemButtonInput } from '@trackback/widgets';
import { AsyncPipe } from '@angular/common';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { MatListModule } from '@angular/material/list';
import { ACTION_DISPATCHER } from '@app/models/action-dispatcher.model';

@Component({
  selector: 'tb-list-item-button',
  imports: [DynamicWidgetDirective, MatListModule, AsyncPipe, ParsePipe],
  template: `
    <button
      mat-list-item
      [class]="input().styleClasses | parse: context() | async"
      [disabled]="input().disabled | parse: context() | async"
      [activated]="input().activated | parse: context() | async"
      [lines]="input().lineCount | parse: context() | async"
      (click)="
        actionDispatcher.dispatch(input().onClick, context()).toPromise()
      "
    >
      @if (input().avatar) {
        <div matListItemAvatar>
          <ng-container
            [dynamicWidget]="input().avatar"
            [context]="context()"
          />
        </div>
      }
      @if (input().icon) {
        <div matListItemIcon>
          <ng-container [dynamicWidget]="input().icon" [context]="context()" />
        </div>
      }
      @if (input().title) {
        <div matListItemTitle>
          <ng-container [dynamicWidget]="input().title" [context]="context()" />
        </div>
      }
      @for (line of input().lines; track $index) {
        <ng-container [dynamicWidget]="line" [context]="context()" />
      }
      @if (input().meta) {
        <div matListItemMeta>
          <ng-container [dynamicWidget]="input().meta" [context]="context()" />
        </div>
      }
    </button>
  `,
  styles: `
    tb-list-item-button {
      display: contents;
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class ListItemButtonComponent {
  input = input.required<ListItemButtonInput>();
  context = input.required<Record<string, never>>();

  actionDispatcher = inject(ACTION_DISPATCHER);
}
